export default "__VITE_ASSET__CA$71tOf__"